module.exports = __webpack_public_path__ + "static/media/ed-sales.b45ff726.png";